// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ElementInspector_overlay__WhskC","infoPanel":"ElementInspector_infoPanel__KoUuY"};